import {Component} from 'react'

class UserTransactions extends Component {
  render() {
    return (
      <>
        <h1>User Transactions</h1>
      </>
    )
  }
}

export default UserTransactions
